import { HTMLAttributes } from 'react'

import Media from '@/components/base/media'
import Typography from '@/components/base/typography'
import { sanitizeAdsLink } from '@/utils/path'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

type ProductGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      image: WPImage
      title: string
      paragraph: string
      link: {
        url: string
        title: string
        target: string
      }
    }[]
  }>

const ProductGrid = ({ items, className }: ProductGridProps) => {
  return (
    <div className={cn('px-[3rem] md:px-[10rem]', className)}>
      <div
        className={cn('grid grid-cols-1 gap-[4rem]', {
          'md:grid-cols-2': items?.length === 2,
          'md:grid-cols-3': (items?.length ?? 0) > 2
        })}
      >
        {items?.map((item, index) => (
          <div key={index} className="relative flex flex-col gap-[2rem]">
            {item.link?.url ? (
              <a
                href={sanitizeAdsLink(item.link.url)}
                target={item.link.target}
                rel="noopener noreferrer"
                className="contents"
              >
                {item?.image ? (
                  <div
                    className={cn(
                      'relative z-10 aspect-[16/9] w-full overflow-hidden rounded-lg'
                    )}
                  >
                    <Media
                      fill
                      fit="cover"
                      use_video={false}
                      image={item.image}
                      data-motion-media
                    />
                  </div>
                ) : null}
                <div className="flex flex-col items-center justify-center gap-[2rem]">
                  {item.title ? (
                    <Typography
                      component="h2"
                      className="text-[2.5rem] font-light leading-[1] md:text-[3.6rem]"
                    >
                      {item.title}
                    </Typography>
                  ) : null}
                  {item.paragraph ? (
                    <Typography component="p">{item.paragraph}</Typography>
                  ) : null}
                  <Typography component="p" className="button">
                    {item.link.title}
                  </Typography>
                </div>
              </a>
            ) : (
              <>
                {item?.image ? (
                  <div
                    className={cn(
                      'relative z-10 aspect-[16/9] w-full overflow-hidden rounded-lg'
                    )}
                  >
                    <Media
                      fill
                      fit="cover"
                      use_video={false}
                      image={item.image}
                      data-motion-media
                    />
                  </div>
                ) : null}
                <div className="flex flex-col items-center justify-center gap-[2rem]">
                  {item.title ? (
                    <Typography
                      component="h1"
                      className="text-[3.6rem] font-light leading-[1]"
                    >
                      {item.title}
                    </Typography>
                  ) : null}
                  {item.paragraph ? (
                    <Typography component="p">{item.paragraph}</Typography>
                  ) : null}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductGrid
